var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PlusCircle = function PlusCircle(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M8.172 12a1 1 0 0 1 1-1H11V9.172a1 1 0 0 1 2 0V11h1.829a1 1 0 0 1 0 2H13v1.828a1 1 0 1 1-2 0V13H9.172a1 1 0 0 1-1-1Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.929 4.929c-3.905 3.905-3.905 10.237 0 14.142 3.905 3.905 10.237 3.905 14.142 0 3.905-3.905 3.905-10.237 0-14.142-3.905-3.905-10.237-3.905-14.142 0Zm1.414 12.728A8 8 0 1 1 17.657 6.343 8 8 0 0 1 6.343 17.657Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default PlusCircle;